import { useState, useEffect, useCallback } from 'react';
import { CustomSnackbars, DateTimePickerCustom, Money, PaymentDashboard, RadioGroup } from '../../components';
import { Box, Button, LinearProgress, Typography, CircularProgress, Stack, Chip, Paper, Grid, Divider, Tabs, Tab, TextField as MuiTextField, InputAdornment } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { ccyFormat } from '../../helpers/helper';
import MovementService from '../../services/movements';
import SaleService from '../../services/sales';
import StoreService from '../../services/stores';
import { TYPE_MOVEMENT } from '../../helpers/enums';
import SalesAnalysisList from '../../components/Table/Mobile/SalesAnalysisList';
import UserService from '../../services/user';
import CustomerService from '../../services/customers';
import StockMovement from '../../components/Table/Mobile/StockMovement';
import { colorDiego, colorJazmin, colorMary, colorSusy } from '../../styles';
import EtiquetaService from '../../services/etiquetas';

const KpiCard = ({ title, value, color = 'primary', subtitle }) => (
  <Paper
    elevation={0}
    sx={(theme) => {
      const palette = theme.palette[color] || theme.palette.primary;
      const mainColor = palette.main;
      return {
        p: 1.6,
        borderRadius: 2,
        border: '1px solid',
        borderColor: alpha(mainColor, 0.35),
        background: `linear-gradient(135deg, ${alpha(mainColor, 0.2)} 0%, ${alpha(mainColor, 0.05)} 100%)`,
        height: '100%'
      }
    }}
  >
    <Typography variant='caption' color='text.secondary' sx={{ textTransform: 'uppercase', letterSpacing: 0.5 }}>
      {title}
    </Typography>
    <Typography variant='h5' sx={(theme) => ({ color: (theme.palette[color] || theme.palette.primary).main, fontWeight: 700, mt: 0.6, lineHeight: 1.15 })}>
      {value}
    </Typography>
    {subtitle && (
      <Typography variant='caption' color='text.secondary' sx={{ lineHeight: 1.2 }}>
        {subtitle}
      </Typography>
    )}
  </Paper>
)

const Analisis = ({ store, setOptions, setChildHeader }) => {
  const [loadingDineroVenta, setLoadingDineroVenta] = useState(false);
  const [loadingDineroCompra, setLoadingDineroCompra] = useState(false);
  const [loadingDineroReinversion, setLoadingDineroReinversion] = useState(false);
  const [loadingDineroDevolucion, setLoadingDineroDevolucion] = useState(false);
  const [loadingPaymentMovements, setLoadingPaymentMovements] = useState(false);
  const [loadingDatas, setLoadingDatas] = useState(false);
  const [ventas, setVentas] = useState([]);
  const [compras, setCompras] = useState([]);
  const [paymentMovements, setPaymentMovements] = useState([]);
  const [filteredVentas, setFilteredVentas] = useState([]);
  const [filteredMoney, setFilteredMoney] = useState([]);
  const [dineroVenta, setDineroVenta] = useState(0);
  const [dineroCompra, setDineroCompra] = useState(0);
  const [dineroReinversion, setDineroReinversion] = useState(0);
  const [dineroDevolucion, setDineroDevolucion] = useState(0);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [users, setUsers] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [saleOptions, setSaleOptions] = useState([]);
  const [selectedSaleOptions, setSelectedSaleOptions] = useState('all');
  const [selectedDineroOptions, setSelectedDineroOptions] = useState('all');
  const [selectedPaymentType, setSelectedPaymentType] = useState('all');
  //const [selectedCashOrTransferOptions, setSelectedCashOrTransferOptions] = useState('all');
  const [money, setMoney] = useState({});
  const [moneyTotal, setMoneyTotal] = useState({});
  const [prossesing, setProssesing] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [messageSnackbar, setMessageSnackbar] = useState('');
  const [activeTab, setActiveTab] = useState(0);
  const [etiquetasHours, setEtiquetasHours] = useState('');

  const loadUsers = useCallback(async () => {
    var resp = await UserService.getAll()
    var respFiltered = resp.filter(u => u.name !== '' && u.name !== 'Diego Cesar')
    setUsers(respFiltered)
  }, [])

  const loadCustomers = useCallback(async () => {
    var resp = await CustomerService.getAll()
    setCustomers(resp)
  }, [])

  useEffect(() => {
    if (users.length === 0) {
      loadUsers()
    }
    if (customers.length === 0) {
      loadCustomers()
    }
  }, [users.length, customers.length, loadUsers, loadCustomers])

  const onCHangeDates = (dateFrom, dateTo) => {
    console.log(dateFrom)
    console.log(dateTo)
    setStartDate(dateFrom?.toDate())
    setEndDate(dateTo?.toDate())
  }

  const loadMovementsByDate = async () => {
    setLoadingDatas(true)
    await Promise.all([
      getMovementsDevolucion(),
      getMovementsVenta(),
      getMovementsCopmra(),
      getMovementsReinversion(),
      getVentas(),
      getCompras(),
      getPaymentMovements(),
    ])
    setLoadingDatas(false)
  }

  const getPaymentMovements = async () => {
    setLoadingPaymentMovements(true)
    var resp = await MovementService.searchPaymentMovements(`date=${startDate}&dateTo=${endDate}`)
    setPaymentMovements(resp)
    setLoadingPaymentMovements(false)
  }

  const getMovementsDevolucion = async () => {
    setLoadingDineroDevolucion(true)
    var resp = await MovementService.searchMovements(store._id, `date=${startDate}&dateTo=${endDate}&type=${TYPE_MOVEMENT.DEVOLUCION}`)
    setDineroDevolucion(calculateSuma(resp))
    setLoadingDineroDevolucion(false)
  }

  const getMovementsVenta = async () => {
    setLoadingDineroVenta(true)
    var dev = await MovementService.searchMovements(store._id, `date=${startDate}&dateTo=${endDate}&type=${TYPE_MOVEMENT.DEVOLUCION}`)
    const totalDev = calculateSuma(dev)
    setDineroDevolucion(totalDev)
    var resp = await MovementService.searchMovements(store._id, `date=${startDate}&dateTo=${endDate}&type=${TYPE_MOVEMENT.VENTA}`)
    setDineroVenta(calculateSuma(resp) - totalDev)
    setLoadingDineroVenta(false)
  }

  const getMovementsCopmra = async () => {
    setLoadingDineroCompra(true)
    var resp = await MovementService.searchMovements(store._id, `date=${startDate}&dateTo=${endDate}&type=${TYPE_MOVEMENT.GASTO}`)
    setDineroCompra(calculateSuma(resp))
    setLoadingDineroCompra(false)
  }

  const getMovementsReinversion = async () => {
    setLoadingDineroReinversion(true)
    var resp = await MovementService.searchMovements(store._id, `date=${startDate}&dateTo=${endDate}&type=${TYPE_MOVEMENT.REINVERSION}`)
    setDineroReinversion(calculateSuma(resp))
    setLoadingDineroReinversion(false)
  }

  const past16Hs = (date) => {
      console.log('date', date);
      const horaActual = new Date(date).getHours();
      return horaActual >= 16;
  }

  const getPaymentAmount = (sale, paymentName) => {
    if (!sale?.payments || !Array.isArray(sale.payments)) return 0;
    const payment = sale.payments.find(p => p?.name?.toLowerCase() === paymentName);
    return Number(payment?.amount || 0);
  }

  const isRelevantSale = (sale) => ['finalizada', 'reservada'].includes(sale?.status?.toLowerCase());

  const calculatePaymentSummary = (salesList = []) => {
    return salesList.reduce((acc, sale) => {
      if (!isRelevantSale(sale)) return acc;
      (sale.payments || []).forEach(p => {
        const name = p?.name?.toLowerCase();
        if (!name || Number(p?.amount || 0) <= 0) return;
        if (!acc[name]) acc[name] = { count: 0, total: 0 };
        acc[name].count += 1;
        acc[name].total += Number(p.amount);
      });
      return acc;
    }, {});
  }

  const getVentas = async () => {
    var resp = await SaleService.searchSales(store._id, `date=${startDate}&dateTo=${endDate}`)
    var money = resp?.reduce((item, m) => {
      if (isRelevantSale(m)) {
        const deposito = Number(m.deposit || 0);
        const suffix = m.updated_at && past16Hs(m.updated_at) ? '_t' : '_m';
        (m.payments || []).forEach(p => {
          const name = p?.name?.toLowerCase();
          if (!name) return;
          const key = `${name}${suffix}`;
          item[key] = (item[key] || 0) + Number(p?.amount || 0);
        });
        item.deposito += deposito;
      }
      return item;
    }, { deposito: 0 })

    setMoneyTotal(money)
    setMoney(money)
    setVentas(resp)
    setFilteredVentas(resp)
    setFilteredMoney(resp?.filter(isRelevantSale) || [])
    calculateSaleOptions(resp)
  }

  const getCompras = async () => {
    var resp = await StoreService.searchStockMovements(store._id, `date=${startDate}&dateTo=${endDate}&type=increment`)
    setCompras(resp)
  }

  const calculateSaleOptions = (ventas) => {
    var status = [...(new Set(ventas?.map(item => item.status)))]
    setSaleOptions(status.map(s => ({ name: s, _id: s })).concat({ name: 'Todas', _id: 'all' }))
  }

  const calculateSuma = (movements) => movements ? movements.reduce((accumulator, currentItem) => {
    return accumulator + currentItem.amount;
  }, 0) : 0;

  useEffect(() => {
    let saleFiltered = ventas

    if (selectedSaleOptions !== 'all') {
      saleFiltered = saleFiltered.filter(v => v.status === selectedSaleOptions)
    }

    if (selectedPaymentType !== 'all') {
      saleFiltered = saleFiltered.filter(v =>
        (v.payments || []).some(p => p?.name?.toLowerCase() === selectedPaymentType && Number(p?.amount || 0) > 0)
      )
    }

    setFilteredVentas(saleFiltered)
  }, [selectedSaleOptions, selectedPaymentType, ventas])

  // useEffect(() => {
  //   if (sel === 'all') {
  //     setFilteredMoney(ventas)
  //   } else {
  //     var saleFiltered = ventas.filter(v => !v.payments && v.payments?.some(p => p.name.toLowerCase() === selectedCashOrTransferOptions && p.amount > 0))
  //     setFilteredMoney(saleFiltered)
  //   }
  //   setLoadingDatas(false)
  // }, [selectedCashOrTransferOptions])

  useEffect(() => {
    if (['all', ''].includes(selectedDineroOptions)) {
      setMoney(moneyTotal)
      setFilteredMoney(ventas?.filter(isRelevantSale) || [])
      return
    }

    const totalMatch = selectedDineroOptions.match(/^(.+)_total$/)
    const partialMatch = !totalMatch && selectedDineroOptions.match(/^(.+)_(m|t)$/)

    if (totalMatch) {
      const typeName = totalMatch[1]
      const filtered = Object.fromEntries(
        Object.entries(moneyTotal || {}).map(([k, v]) => {
          if (k === 'deposito') return [k, v]
          const m = k.match(/^(.+)_(m|t)$/)
          return [k, m && m[1] === typeName ? v : 0]
        })
      )
      setMoney(filtered)
      setFilteredMoney((ventas || []).filter(v =>
        isRelevantSale(v) && (v.payments || []).some(p => p?.name?.toLowerCase() === typeName && Number(p?.amount || 0) > 0)
      ))
    } else if (partialMatch) {
      const typeName = partialMatch[1]
      const suffix = partialMatch[2]
      const filtered = Object.fromEntries(
        Object.entries(moneyTotal || {}).map(([k, v]) => [k, k === selectedDineroOptions ? v : (k === 'deposito' ? v : 0)])
      )
      setMoney(filtered)
      const isAfternoon = suffix === 't'
      setFilteredMoney((ventas || []).filter(v =>
        isRelevantSale(v) &&
        (v.payments || []).some(p => p?.name?.toLowerCase() === typeName && Number(p?.amount || 0) > 0) &&
        (isAfternoon ? past16Hs(v.updated_at) : !past16Hs(v.updated_at))
      ))
    } else {
      setMoney(moneyTotal)
      setFilteredMoney(ventas?.filter(isRelevantSale) || [])
    }
  }, [selectedDineroOptions, moneyTotal, ventas])

  const paymentSummary = calculatePaymentSummary(filteredVentas || [])
  const totalPayments = Object.entries(moneyTotal || {})
    .filter(([k]) => k !== 'deposito')
    .reduce((sum, [, v]) => sum + Number(v || 0), 0)
  const paymentTypeTotals = Object.entries(moneyTotal || {})
    .filter(([k]) => k !== 'deposito')
    .reduce((acc, [key, val]) => {
      const m = key.match(/^(.+)_(m|t)$/)
      if (!m) return acc
      acc[m[1]] = (acc[m[1]] || 0) + Number(val || 0)
      return acc
    }, {})

  const comprasParaEtiquetas = etiquetasHours
    ? compras.filter(c => {
        const d = new Date(c.created_at || c.date);
        return (Date.now() - d.getTime()) <= etiquetasHours * 3600000;
      })
    : compras;

  const etiquetasToPrint = (arts) => {
    var articulos = []
    arts?.forEach(art =>
      articulos = [...articulos, ...(Array(art.quantity).fill(null).map(() => ({ ...art })))]
    )
    return articulos
  };

  const descargarEtiquetas = async (etqs) => {
    try {
      setProssesing(true)
      const response = await EtiquetaService.generate(etqs);

      console.log(response.data);

      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = "etiquetas.pdf";
      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(url);
      setMessageSnackbar('PDF con etiqutas generado')
      setShowSnackbar(true)
    } catch (err) {
      alert("Hubo un problema al descargar el archivo");
      console.error(err);
    }
  };

  return <Box display='flex' minHeight='100%' maxWidth='100%' flexDirection='column' marginTop={2} sx={{ bgcolor: 'background.paper' }}>
    <Paper elevation={0} sx={{ p: { xs: 1.2, md: 1.5 }, borderRadius: 2, border: '1px solid', borderColor: 'divider', mb: 1.2 }}>
      <Stack direction={{ xs: 'column', md: 'row' }} spacing={2} alignItems={{ xs: 'stretch', md: 'center' }} justifyContent='space-between'>
        <Box>
          <Typography variant='h5' fontWeight={700}>Análisis financiero</Typography>
          <Typography variant='body2' color='text.secondary'>Resumen de ventas, compras y medios de pago por período</Typography>
        </Box>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} alignItems={{ xs: 'stretch', sm: 'center' }}>
          <DateTimePickerCustom onChange={onCHangeDates} interval startDate={startDate} endDate={endDate} />
          <Button variant='contained' onClick={loadMovementsByDate}>Buscar</Button>
        </Stack>
      </Stack>
    </Paper>

    {(loadingDatas || loadingDineroVenta || loadingDineroCompra || loadingDineroReinversion || loadingDineroDevolucion) && <LinearProgress sx={{ mb: 1.2 }} />}

    <Grid container spacing={1.2} mb={1.2}>
      <Grid item xs={12} sm={6} md={3}>
        <KpiCard title='Ventas netas' value={`$${ccyFormat(dineroVenta)}`} color='success' subtitle='Ventas - devoluciones' />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <KpiCard title='Compras' value={`$${ccyFormat(dineroCompra)}`} color='error' subtitle='Gastos de compra' />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <KpiCard title='Reinversión' value={`$${ccyFormat(dineroReinversion)}`} color='warning' subtitle='Movimientos reinvertidos' />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <KpiCard title='Devoluciones' value={`$${ccyFormat(dineroDevolucion)}`} color='info' subtitle='Devoluciones en período' />
      </Grid>
    </Grid>

    <Grid container spacing={1.2} mb={1.2}>
      {Object.entries(paymentTypeTotals).map(([name, total]) => (
        <Grid item xs={12} sm={6} md={4} key={name}>
          <KpiCard title={`Cobrado en ${name}`} value={`$${ccyFormat(total)}`} color='success' subtitle={`${paymentSummary[name]?.count || 0} ventas`} />
        </Grid>
      ))}
      <Grid item xs={12} sm={6} md={4}>
        <KpiCard title='Cobro total (medios)' value={`$${ccyFormat(totalPayments)}`} color='primary' subtitle='Todos los medios' />
      </Grid>
    </Grid>

    <Paper elevation={0} sx={{ borderRadius: 2, border: '1px solid', borderColor: 'divider', overflow: 'hidden' }}>
      <Tabs
        value={activeTab}
        onChange={(_, value) => setActiveTab(value)}
        variant='scrollable'
        scrollButtons='auto'
        sx={{ px: 1, borderBottom: '1px solid', borderColor: 'divider' }}
      >
        <Tab label='Ventas' />
        <Tab label='Compras' />
        <Tab label='Efectivo / Transferencia' />
        <Tab label='Dinero en cuenta' />
      </Tabs>

      <Box p={{ xs: 1.1, md: 1.4 }}>
        {activeTab === 0 && (
          <>
            <Stack display='flex' paddingBottom={1} direction='row' justifyContent='space-between' flexWrap='wrap' gap={0.8}>
              <Chip label='Jazmin MyA' sx={{ background: colorJazmin }} />
              <Chip label='Mary' sx={{ background: colorMary }} />
              <Chip label='Diego' sx={{ background: colorDiego }} />
              <Chip label='Susy' sx={{ background: colorSusy }} />
            </Stack>
            <Stack display='flex' paddingBottom={1} direction={{ xs: 'column', sm: 'row' }} spacing={1} justifyContent='space-between' flexWrap='wrap'>
              {Object.entries(paymentSummary).map(([name, data]) => (
                <Chip key={name} label={`${name.charAt(0).toUpperCase() + name.slice(1)}: ${data.count} ventas | $${ccyFormat(data.total)}`} />
              ))}
            </Stack>
            <RadioGroup options={saleOptions} selectedValue={selectedSaleOptions} onValueChange={value => setSelectedSaleOptions(value)} />
            <RadioGroup
              options={[
                { _id: 'all', name: 'Todos los medios' },
                ...Object.keys(paymentTypeTotals).map(name => ({
                  _id: name,
                  name: name.charAt(0).toUpperCase() + name.slice(1),
                })),
              ]}
              selectedValue={selectedPaymentType}
              onValueChange={value => setSelectedPaymentType(value)}
            />
            <Divider sx={{ my: 1 }} />
            <SalesAnalysisList salesData={filteredVentas} groupByDate viewDetail />
          </>
        )}

        {activeTab === 1 && (
          <>
            <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent='space-between' alignItems={{ xs: 'stretch', sm: 'center' }} mb={2} gap={1.5} flexWrap='wrap'>
              <Stack direction='row' alignItems='center' spacing={1.5}>
                <Typography variant='subtitle1' fontWeight={600}>Compras y stock ingresado</Typography>
                <MuiTextField
                  size='small'
                  label='Últimas N horas'
                  placeholder='ej: 0.25 = 15min'
                  value={etiquetasHours}
                  onChange={(e) => setEtiquetasHours(e.target.value === '' ? '' : Number(e.target.value))}
                  type='number'
                  inputProps={{ min: 0, step: 0.25 }}
                  sx={{ width: 170 }}
                  InputProps={{
                    endAdornment: etiquetasHours !== '' && (
                      <InputAdornment position='end'>
                        <Typography variant='caption' color='text.secondary'>hs</Typography>
                      </InputAdornment>
                    )
                  }}
                />
              </Stack>
              {prossesing ? <CircularProgress size='1.5rem' /> : <Button
                onClick={() => {
                  descargarEtiquetas(etiquetasToPrint(comprasParaEtiquetas))
                  setProssesing(false)
                }}
                variant='contained'
                color='inherit'
              >
                {`Generar ${etiquetasToPrint(comprasParaEtiquetas).length} etiquetas`}
              </Button>}
            </Stack>
            <StockMovement customers={customers} readonly compras={compras} loading={loadingDatas} />
          </>
        )}

        {activeTab === 2 && (
          <>
            <RadioGroup
              options={[
                { _id: 'all', name: 'TODOS' },
                ...Object.keys(moneyTotal || {})
                  .filter(k => k !== 'deposito' && /^.+_(m|t)$/.test(k))
                  .reduce((acc, k) => {
                    const [, typeName, suffix] = k.match(/^(.+)_(m|t)$/)
                    const label = typeName.charAt(0).toUpperCase() + typeName.slice(1)
                    if (!acc.some(o => o._id === `${typeName}_total`)) {
                      acc.push({ _id: `${typeName}_total`, name: `${label} total`, description: `pago en ${typeName} totalmente` })
                    }
                    acc.push({
                      _id: k,
                      name: `${label} ${suffix === 'm' ? 'mañana' : 'tarde'}`,
                      description: `pago en ${typeName} por la ${suffix === 'm' ? 'mañana' : 'tarde'}`,
                    })
                    return acc
                  }, []),
              ]}
              selectedValue={selectedDineroOptions}
              onValueChange={value => setSelectedDineroOptions(value)}
            />
            <Divider sx={{ my: 1 }} />
            <SalesAnalysisList salesData={filteredMoney} groupByDate />
            <Divider sx={{ my: 1 }} />
            <Money readonly money={money} loading={loadingDatas} />
          </>
        )}

        {activeTab === 3 && (
          loadingPaymentMovements
            ? <CircularProgress size='1.5rem' />
            : <PaymentDashboard paymentMovements={paymentMovements} />
        )}
      </Box>
    </Paper>

    <CustomSnackbars show={showSnackbar} onClose={() => setShowSnackbar(false)} message={messageSnackbar} />
  </Box>
}

export default Analisis;
